/**
 * ScheduleSection - Schedule section for scroll wizard
 */
import React, { useState } from 'react';
import { useTournament } from '../../contexts/TournamentContext';

const ScheduleSection = () => {
  const { schedule, players, courts } = useTournament();
  const [openRounds, setOpenRounds] = useState({ 0: true });

  const getPlayerName = (playerId) => {
    const player = players.find((p) => p.id === playerId);
    return player ? player.name : `Joueur ${playerId}`;
  };

  const getCourtName = (courtIndex) => {
    return courts?.[courtIndex]?.name || `Terrain ${courtIndex + 1}`;
  };

  const toggleRound = (roundIndex) => {
    setOpenRounds(prev => ({
      ...prev,
      [roundIndex]: !prev[roundIndex]
    }));
  };

  return (
    <div className="section-inner">
      <div className="section-header">
        <h1>
          <i className="bi bi-calendar3 me-3"></i>
          Planning
        </h1>
      </div>

      <div className="section-body">
        {schedule?.rounds?.map((round, roundIndex) => (
          <div key={roundIndex} className="round-card mb-3">
            {/* Round Header - Clickable */}
            <div
              className={`round-header ${openRounds[roundIndex] ? 'open' : ''}`}
              onClick={() => toggleRound(roundIndex)}
            >
              <h5>
                <i className="bi bi-trophy me-2"></i>
                Tour {roundIndex + 1}
                <span className="match-count">
                  ({round.matches?.length || 0} matchs)
                </span>
              </h5>
              <i className={`bi bi-chevron-${openRounds[roundIndex] ? 'up' : 'down'}`}></i>
            </div>

            {/* Round Content - Collapsible */}
            {openRounds[roundIndex] && (
              <div className="matches-list">
                {round.matches?.map((match, matchIndex) => (
                  <div key={matchIndex} className="match-line">
                    <strong>{getCourtName(matchIndex)}</strong> : {' '}
                    {match.team1.map((id) => getPlayerName(id)).join(' / ')} {' '}
                    <span className="vs">vs</span> {' '}
                    {match.team2.map((id) => getPlayerName(id)).join(' / ')}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScheduleSection;
